import * as ethValue from './StaticStore';
import { ethers } from 'ethers';
import { dappStore } from '@components/store/';

export default class Contracts {
  arch;
  ousd;
  levEngine;

  signer;
  signerAddress;

  constructor(signer) {
    return this.setup(signer);
  }

  setup = (signer) => {
    const addresses = dappStore.getState().addresses;
    this.signer = signer;
    this.signer.getAddress().then((address) => (this.signerAddress = address));
    this.arch = new ethers.Contract(addresses.archTokenAddress, ethValue.erc20abi, this.signer);
    this.ousd = new ethers.Contract(addresses.ousdAddress, ethValue.erc20abi, this.signer);
    this.usdt = new ethers.Contract(addresses.usdtAddress, ethValue.erc20abi, this.signer);
    this.usdc = new ethers.Contract(addresses.usdcAddress, ethValue.erc20abi, this.signer);
    this.dai = new ethers.Contract(addresses.daiAddress, ethValue.erc20abi, this.signer);
    this.levEngine = new ethers.Contract(addresses.levEngineAddress, ethValue.LevEngineAbi, this.signer);
    this.positionToken = new ethers.Contract(addresses.positionTokenAddress, ethValue.PositionTokenAbi, this.signer);
    this.cdp = new ethers.Contract(addresses.cdpAddress, ethValue.cdpAbi, this.signer);
    this.vault = new ethers.Contract(addresses.vaultAddress, ethValue.VaultAbi, this.signer);
    this.zapper = new ethers.Contract(addresses.zapperAddress, ethValue.zapperAbi, this.signer);
    this.coordinator = new ethers.Contract(addresses.coordinatorAddress, ethValue.coordinatorAbi, this.signer);
    return this;
  };
}
